import * as React from "react";
import { useContext } from "react";
import styled from "styled-components";
import WidgetDetailsContext from "report/report-creation/WidgetDetailsContext";
import ReportParameters from "./ReportParameters";
import WidgetsList from "./WidgetsList";
import AddWidget from "./AddWidget";
const Header = styled.h3`
  margin-bottom: 15px;
`;
const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: baseline;
  justify-items: center;
  justify-content: space-between;
`;
const Content = ({ editAllowed }) => {
  const { searchIds, parameters } = useContext(WidgetDetailsContext);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, Object.keys(parameters).length > 0 ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(HeaderContainer, null, /* @__PURE__ */ React.createElement(Header, null, "Required Parameters")), /* @__PURE__ */ React.createElement(ReportParameters, { parameters, parameterSearchIds: searchIds })) : null, /* @__PURE__ */ React.createElement(HeaderContainer, null, /* @__PURE__ */ React.createElement(Header, null, "Widgets"), /* @__PURE__ */ React.createElement(AddWidget, { disabled: !editAllowed })), /* @__PURE__ */ React.createElement(WidgetsList, { disabled: !editAllowed }));
};
export default Content;
